import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-73cf9cd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "counter-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Стоимость сегмента", -1))
const _hoisted_3 = { class: "count" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, " ₽ ", -1))
const _hoisted_6 = {
  key: 1,
  class: "value"
}

import { ref, watch } from "vue";
import { formatNumber } from "@/services/utils/Strings";


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentCostCounter',
  props: {
    settedCost: {}
  },
  emits: ["updateSegmentCost"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emits = __emit;

const cost = ref<number | null | undefined>(props.settedCost);

watch(
  () => props.settedCost,
  (newValue) => {
    cost.value = newValue;
  }
);

const updateCost = (newCost: number) => {
  cost.value = newCost;
  emits("updateSegmentCost", newCost);
};

__expose({
  updateCost,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (cost.value !== null && cost.value !== undefined)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatNumber)(cost.value)), 1),
            _hoisted_5
          ], 64))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, "—"))
    ])
  ]))
}
}

})